import {useEffect, useMemo, useState} from 'react';
import { mapProductIdToTag } from '@/components/utils/utils';
import { useGetFeatureKeys, useGetSubscriptionStatusQuery } from '@viome/viome-base/src/usecase/Misc/MiscQuery';
import { KEYS, LocalStorage } from '@utils/LocalStorage.ts';

const useStorifyConfig = (isSingleStory = false) => {
  const localStorageUser = LocalStorage.getItem(KEYS.BOOTUP);
  const { kitType } = localStorageUser && JSON.parse(localStorageUser);
  const {
    data,
    isLoading: isStoriesLoading,
    isSuccess,
  } = useGetSubscriptionStatusQuery();
  const { data: featureKeys } = useGetFeatureKeys();
  const [tags, setTags] = useState<string[]>([]);

  const isStorifyEnabled = featureKeys?.storify_enabled || false;
  const storifyWidgetId = featureKeys?.storify_widget_id || "8612";

  const subscriptionData = useMemo(() => {
    if (!isStorifyEnabled) {
      return;
    }
    const products = data?.products ?? [];

    const subscribedProducts = products
      .filter((item) => item?.is_subscribed)
      .map((element) => mapProductIdToTag(element.id));

    //tag has NOT-SUBSCRIBED, SUBSCRIBED,CANCELED-SUBSCRIBED
    const otherTags = data?.subscription_details?.tag ?? '';

    //CONCIERGE, STANDARD
    const subscriptionType = data?.subscription_details?.type ?? '';

    return { otherTags, subscriptionType, subscribedProducts };
  }, [data, isStorifyEnabled]);

  useEffect(() => {
    if (!isStorifyEnabled) {
      return;
    }
    if (isSingleStory) {
      if (kitType) {
        setTags([`${kitType}-RR`]);
      } else {
        setTags(['RECOMMENDATION-ONBOARDING-FIRST-WEEK']);
      }
    } else {
      setTags((prevTags) => {
        const newTags = [...prevTags, kitType];
        if (
          isSuccess &&
          subscriptionData?.subscribedProducts &&
          subscriptionData?.subscribedProducts.length > 0
        ) {
          newTags.push(...subscriptionData.subscribedProducts);
        }
        if (subscriptionData?.otherTags) {
          newTags.push(subscriptionData.otherTags);
        }
        if (subscriptionData?.subscriptionType) {
          newTags.push(subscriptionData.subscriptionType);
        }
        newTags.push('ALL-USER');
        return [...new Set(newTags.filter(Boolean))];
      });
    }
  }, [isSuccess, subscriptionData, kitType, isStorifyEnabled]);

  return {
    tags,
    isStoriesLoading,
    isStorifyEnabled,
    storifyWidgetId,
  };
};

export default useStorifyConfig;
